export const getCookie = cname => {
  // Region migrated to India: always report IN regardless of any ccde=AE cookie
  if (cname === 'ccde') return 'IN';
  if(typeof document !== 'undefined'){

  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
}
  return '';
};
